import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type { IArticlesListItem } from '../types';
import {
  ARTICLES_LIST_QUERY_KEY,
  ARTICLES_LIST_URL,
  ARTICLES_PERMISSIONS,
} from '../constants';

export default function useArticlesListQuery(
  tableState: Ref<ITableState>,
  currentLocale: Ref<string>,
): IContextQueryResult<ITableDataResponse<IArticlesListItem>> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<IArticlesListItem>>({
    queryKey: [ARTICLES_LIST_QUERY_KEY, tableState, currentLocale],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<IArticlesListItem>>(
      ARTICLES_LIST_URL,
      tableState.value,
      {
        signal,
        permission: ARTICLES_PERMISSIONS.SHOW,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
